import React, { useEffect, useLayoutEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Form } from 'semantic-ui-react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import {
  attachNewCard,
  deactivateBindingAndGetSavedCards,
  getSavedCards,
  makeCardDefaultAndGetSavedCards,
} from '../../../redux/modules/payment';
import PaymentCard from '../PaymentCard/PaymentCard';
import Loader from '../../Loaders/Loader';
import { ERROR_STATES } from '../../Confirmation/options';
import { showNotification } from '../../../helpers/notificationHelpers';
import { ATTACH_PAYMENT_CARD_OPTIONS } from '../../../constants';

import addCardLogo from '../../../img/addCard.svg';
import styles from './MyCards.module.scss';

const MyCardsPage = () => {
  const { transactionBinding } = useSelector((store) => store.paymentReducer, shallowEqual);
  const { savedCards, isLoading } = transactionBinding;
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const urlParams = queryString.parse(location.search);
    const urlSuccess = urlParams.success;
    if (urlSuccess === '0') {
      let error = ERROR_STATES.DEFAULT;
      if (urlParams.error && Object.keys(ERROR_STATES).includes(urlParams.error)) {
        error = ERROR_STATES[urlParams.error];
      }
      showNotification(error.description, 'error', 'ATTACH_CARD_ERROR');
    } else if (urlSuccess === '1') {
      showNotification('paymentConfirmation.addCardSuccessText', 'success', 'ATTACH_CARD_SUCCESS');
    }
  }, [location.search, t]);

  useLayoutEffect(() => {
    if (isAuthenticated) {
      dispatch(getSavedCards());
    }
  }, [dispatch, isAuthenticated]);

  const handleRemoveCard = (cardHolderId) => {
    dispatch(deactivateBindingAndGetSavedCards(cardHolderId));
  };

  const handleMakeDefault = (cardHolderId) => {
    dispatch(makeCardDefaultAndGetSavedCards(cardHolderId));
  };

  const handleAddNewCard = () => {
    dispatch(attachNewCard(ATTACH_PAYMENT_CARD_OPTIONS.ATTACH_CARD));
  };

  if (isLoading) {
    return (
      <div className={styles.loader}>
        <Loader />
      </div>
    );
  }

  return (
    <Form>
      <div className={styles.cardsContainer}>
        <div id={styles.header}>
          <div className="header" id={styles.headerTitle}>{t('headerTitles.myCards')}</div>
          {savedCards.length ? (
            <div className={styles.addCard} onClick={handleAddNewCard} role="presentation">
              <div className={styles.logoContainer}>
                <img src={addCardLogo} alt="Logo" />
              </div>
              <span className={styles.addCardText}>{t('myCards.addNewCard')}</span>
            </div>
          ) : <div />}
        </div>

        {savedCards.length ? <></> : (
          <div className={styles.addCardSecond}>
            <div className={styles.logoContainerSecond}>
              <img src={addCardLogo} alt="Logo" />
            </div>
            <div className={styles.attention}>{t('myCards.attentionMsg')}</div>
            <div className={styles.addCardButtonContainer} onClick={handleAddNewCard} role="presentation">
              <button type="button" className={styles.addCardButton}>{t('myCards.addNewCard')}</button>
            </div>
          </div>
        )}
        <div className={styles.cardWrapper}>
          {!!savedCards.length && savedCards.map((card) => (
            <PaymentCard
              card={card}
              key={card.cardPan}
              removeCard={handleRemoveCard}
              makeDefault={handleMakeDefault}
            />
          ))}
        </div>
      </div>
    </Form>

  );
};

export default MyCardsPage;
